import script from "./UserManagementTreeNode.vue?vue&type=script&setup=true&lang=js"
export * from "./UserManagementTreeNode.vue?vue&type=script&setup=true&lang=js"

import "./UserManagementTreeNode.vue?vue&type=style&index=0&id=49ff7e74&lang=scss&scoped=true"

import exportComponent from "/root/buildarea/v8-development-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49ff7e74"]])

export default __exports__